import { useEffect, useState } from 'react'
import { api } from '../api'
import { Card, Row, Col, Statistic, Button, Typography, Space } from 'antd'
import {
  EnvironmentOutlined, BookOutlined, InboxOutlined,
  EuroOutlined, ClockCircleOutlined, TeamOutlined,
  LogoutOutlined, ExperimentOutlined, SettingOutlined, CloudOutlined, CarOutlined,
  MedicineBoxOutlined, IdcardOutlined, SolutionOutlined
} from '@ant-design/icons'

const { Title, Text } = Typography

export default function Dashboard({ usuario, onLogout, onNavegar }) {
  const [stats, setStats] = useState({ parcelas: 0, costes: 0, jornales: 0 })
  const [config, setConfig] = useState({})
  const [tieneFicha, setTieneFicha] = useState(false)

  const rol = usuario?.rol || 'usuario'

  useEffect(() => {
    if (rol !== 'tecnico') {
      api('/dashboard/stats').then(data => setStats(data)).catch(() => {})
    }
    api('/config').then(data => setConfig(data)).catch(() => {})
    api('/trabajadores/me').then(data => setTieneFicha(!!data)).catch(() => {})
  }, [rol])

  const todosModulos = [
    { icon: <ExperimentOutlined style={{ fontSize: '28px', color: '#2E7D32' }} />, nombre: 'Cultivos', desc: 'Ciclos de producción', pagina: 'cultivos', roles: ['admin', 'tecnico', 'operario', 'usuario'] },
    { icon: <BookOutlined style={{ fontSize: '28px', color: '#1B5E20' }} />, nombre: 'Cuaderno de campo', desc: 'Registros por parcela', pagina: 'cuaderno', roles: ['admin', 'operario'] },
    { icon: <MedicineBoxOutlined style={{ fontSize: '28px', color: '#C62828' }} />, nombre: 'Tratamientos', desc: 'Planificación de aplicaciones', pagina: 'tratamientos', roles: ['admin', 'tecnico'] },
    { icon: <EnvironmentOutlined style={{ fontSize: '28px', color: '#33691E' }} />, nombre: 'Parcelas', desc: 'Gestión de fincas', pagina: 'parcelas', roles: ['admin', 'tecnico', 'operario', 'usuario'] },
    { icon: <CloudOutlined style={{ fontSize: '28px', color: '#0288D1' }} />, nombre: 'Riegos', desc: 'Gestión de riego', pagina: 'riegos', roles: ['admin', 'tecnico', 'operario'] },
    { icon: <InboxOutlined style={{ fontSize: '28px', color: '#E65100' }} />, nombre: 'Inventario', desc: 'Productos y stock', pagina: 'inventario', roles: ['admin', 'tecnico', 'operario'] },
    { icon: <EuroOutlined style={{ fontSize: '28px', color: '#1565C0' }} />, nombre: 'Costes', desc: 'Control de gastos', pagina: 'costes', roles: ['admin'] },
    { icon: <ClockCircleOutlined style={{ fontSize: '28px', color: '#6A1B9A' }} />, nombre: 'Jornales', desc: 'Horas y trabajadores', pagina: 'jornales', roles: ['admin'] },
    { icon: <CarOutlined style={{ fontSize: '28px', color: '#00838F' }} />, nombre: 'Servicios Tractor', desc: 'CRM clientes y cobros', pagina: 'servicios', roles: ['admin'] },
    { icon: <SolutionOutlined style={{ fontSize: '28px', color: '#5D4037' }} />, nombre: 'Trabajadores', desc: 'Fichas y documentos', pagina: 'trabajadores', roles: ['admin'] },
    { icon: <TeamOutlined style={{ fontSize: '28px', color: '#00838F' }} />, nombre: 'Usuarios', desc: 'Roles y accesos', pagina: 'usuarios', roles: ['admin'] },
    { icon: <SettingOutlined style={{ fontSize: '28px', color: '#455A64' }} />, nombre: 'Configuración', desc: 'Logo y personalización', pagina: 'configuracion', roles: ['admin'] },
  ]

  // "Mi perfil" sale a cualquiera que tenga ficha de trabajador, sea cual sea su rol
  const miPerfil = { icon: <IdcardOutlined style={{ fontSize: '28px', color: '#2E7D32' }} />, nombre: 'Mi perfil', desc: 'Mis datos y documentos', pagina: 'miperfil' }
  const modulos = [...(tieneFicha ? [miPerfil] : []), ...todosModulos.filter(m => m.roles.includes(rol))]

  return (
    <div style={{ minHeight: '100vh', background: '#f0f2f5' }}>
      <div style={{ background: 'linear-gradient(135deg, #1B3A6B 0%, #2E5FA3 100%)', padding: '24px 20px 28px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            {config.logo_url && (
              <img src={config.logo_url} alt="Logo" style={{ height: '40px', borderRadius: '6px' }} />
            )}
            <div>
              <Text style={{ color: 'rgba(255,255,255,0.6)', fontSize: '13px' }}>Buenos días,</Text>
              <Title level={4} style={{ color: 'white', margin: 0 }}>
                {usuario?.nombre || 'Usuario'}
              </Title>
            </div>
          </div>
          <Button icon={<LogoutOutlined />} onClick={onLogout} ghost size="small">Salir</Button>
        </div>

        {rol !== 'tecnico' && (
          <Row gutter={10}>
            <Col span={8}>
              <Card size="small" style={{ background: 'rgba(255,255,255,0.12)', border: 'none', borderRadius: '12px' }}>
                <Statistic title={<span style={{ color: 'rgba(255,255,255,0.6)', fontSize: '11px' }}>Parcelas</span>} value={stats.parcelas} valueStyle={{ color: 'white', fontSize: '22px' }} />
              </Card>
            </Col>
            <Col span={8}>
              <Card size="small" style={{ background: 'rgba(255,255,255,0.12)', border: 'none', borderRadius: '12px' }}>
                <Statistic title={<span style={{ color: 'rgba(255,255,255,0.6)', fontSize: '11px' }}>Coste total</span>} value={stats.costes} suffix="€" precision={0} valueStyle={{ color: 'white', fontSize: '22px' }} />
              </Card>
            </Col>
            <Col span={8}>
              <Card size="small" style={{ background: 'rgba(255,255,255,0.12)', border: 'none', borderRadius: '12px' }}>
                <Statistic title={<span style={{ color: 'rgba(255,255,255,0.6)', fontSize: '11px' }}>Horas</span>} value={stats.jornales} suffix="h" precision={0} valueStyle={{ color: 'white', fontSize: '22px' }} />
              </Card>
            </Col>
          </Row>
        )}
      </div>

      <div style={{ padding: '20px' }}>
        <Title level={5} style={{ marginBottom: '16px', color: '#1B3A6B' }}>{config.nombre_app || 'Módulos'}</Title>
        <Row gutter={[12, 12]}>
          {modulos.map((m, i) => (
            <Col span={12} key={i}>
              <Card
                hoverable
                onClick={() => onNavegar(m.pagina)}
                style={{ borderRadius: '14px', height: '100%' }}
                styles={{ body: { padding: '20px 16px' } }}
              >
                <Space direction="vertical" size={4}>
                  {m.icon}
                  <Text strong style={{ fontSize: '13px', color: '#1B3A6B' }}>{m.nombre}</Text>
                  <Text type="secondary" style={{ fontSize: '11px' }}>{m.desc}</Text>
                </Space>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  )
}
